module.exports = __webpack_public_path__ + "img/w-cutBag.ca41570a.jpg";